// 9fbef606107a605d69c0edbcd8029e5d
import { css } from 'styled-components';
import { getIconPath } from '@tcp/core/src/utils';

const accordionStyles = css`
  &.accordion {
    min-height: 34px;
    padding: 18px 15px 0;
    margin: 0;
    &.inactive {
      background: ${(props) => props.theme.colors.ACCORDION.INACTIVE_HEADER};
    }
    &.active {
      background: ${(props) => props.theme.colors.ACCORDION.ACTIVE_HEADER};
    }
    &.accordian-head-new {
      background-color: #fafafa;
      border-bottom: 1px solid #e3e3e3;
      width: unset;
    }
  }
  &.active::after {
    ${(props) =>
      props.activeIcon ? `content: url(${getIconPath(props.activeIcon)});` : `content: '+';`}
    right: 15px;
    position: absolute;
    font-weight: bold;
    font-size: 20px;
    color: ${(props) => props.theme.colors.ACCORDION.COLLAPSE_EXPAND_ICON};
    height: 10px;
    width: 10px;
    ${(props) => props.activeIcon && 'top:10px;'}
  }

  &.inactive::after {
    ${(props) =>
      props.inactiveIcon ? `content: url(${getIconPath(props.inactiveIcon)});` : `content: '';`}
    right: 15px;
    position: absolute;
    background: ${(props) =>
      props.inactiveIcon ? `none` : props.theme.colors.ACCORDION.COLLAPSE_EXPAND_ICON};
    height: 2px;
    width: 10px;
    margin-top: ${(props) => (props.inactiveIcon ? `0` : '5px')};
  }
`;

export default accordionStyles;
